import { Box, Typography } from '@mui/material';

export const EmptyReportedContent = () => (
  <Box className="flex flex-col items-center gap-5 mt-[92px]">
    <Typography className="text-[36px] text-gray-4 font-extrabold">
      You are up to date! 🙌
    </Typography>
    <Typography align="center" className="text-gray-4 md:w-[523px] sm:w-[90%]">
      There is no content to be reviewed yet.
    </Typography>
  </Box>
);
